import React, { useState } from 'react';
import { Link as RouterLink, useNavigate, useSearchParams } from 'react-router-dom';
import {
  Alert,
  Box,
  Button,
  Link,
  Paper,
  Stack,
  TextField,
  Typography,
  Fade,
} from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import useAdminAuthStore from '../stores/adminAuthStore';
import './Auth.css';

const AdminSignIn = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const nextPath = searchParams.get('next') || '/admin-cofounder-hubs';
  const { signin, isLoading, error, clearError } = useAdminAuthStore();
  const [formData, setFormData] = useState({
    email: '',
    password: '',
  });

  const handleChange = (e) => {
    clearError();
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const result = await signin(formData.email, formData.password);
    if (result.success) {
      const dest =
        nextPath.startsWith('/admin') ? nextPath : '/admin-cofounder-hubs';
      navigate(dest.startsWith('/') ? dest : '/admin-cofounder-hubs');
    }
  };

  return (
    <Box className="auth-page-container ch-page-enter">
      <Box className="auth-page-main">
        <Fade in timeout={220}>
          <Box className="auth-page-stack ch-card-enter">
            <Link
              component={RouterLink}
              to="/"
              underline="none"
              color="primary"
              className="auth-page-back-link"
              sx={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: 0.5,
                fontSize: '0.875rem',
                fontWeight: 500,
                alignSelf: 'flex-start',
                mb: 1.25,
              }}
            >
              <ArrowBackIcon fontSize="small" />
              Back to Home
            </Link>

            <Paper className="auth-page-box" elevation={0}>
              <Typography variant="h5" component="h1" align="center" sx={{ mb: 2 }}>
                Admin sign in
              </Typography>
              <Typography variant="body2" color="text.secondary" align="center" sx={{ mb: 2 }}>
                This login is separate from the public website. Signing out here will not sign out
                members on the site.
              </Typography>

              <Box component="form" onSubmit={handleSubmit}>
                <Stack spacing={1.25}>
                  {error && <Alert severity="error">{error}</Alert>}

                  <TextField
                    label="Admin email"
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    autoComplete="username"
                  />

                  <TextField
                    label="Password"
                    type="password"
                    name="password"
                    value={formData.password}
                    onChange={handleChange}
                    required
                    autoComplete="current-password"
                  />

                  <Button type="submit" variant="contained" color="primary" disabled={isLoading} fullWidth>
                    {isLoading ? 'Signing in...' : 'Sign in to admin'}
                  </Button>
                </Stack>
              </Box>
            </Paper>
          </Box>
        </Fade>
      </Box>
    </Box>
  );
};

export default AdminSignIn;
